import React from 'react';
import Footer from '../../components/Footer';
import SubFooter from '../../components/SubFooter';
import Img from "../../assets/maya.jpg";
import HighestImg from "../../assets/courses/highest.gif";
import AvgImg from "../../assets/courses/avg.png";
import YearImg from "../../assets/courses/year.gif";
import vc from "../../assets/aboutus/vc.png";

const stats = [
    { id: 1, name: 'Highest Package', value: '43.5 Lakh', image: HighestImg },
    { id: 2, name: 'Average Package', value: '5.48 Lakh', image: AvgImg },
    { id: 3, name: 'Years of Legacy', value: '14', image: YearImg },
];

const Vc_msg = () => {
    return (
        <div className="w-full relative bg-gradient-to-b from-white to-gray-50">
            <h2 className="text-center text-3xl md:text-5xl font-extrabold mt-24 md:mt-36 text-[#0e4d38]">
                Vice Chancellor’s Message
            </h2>

            {/* Top Section */}
            <div className="w-10/12 mx-auto flex flex-col md:flex-row items-center justify-between gap-12 mt-16">
                <img
                    src={vc}
                    alt="President"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
                <div className="space-y-4 md:w-2/3 text-center md:text-left border border-gray-300 rounded-lg p-6 shadow-md bg-white">
                    <h1 className="text-2xl md:text-3xl font-bold text-[#0e4d38]">

                        Prof.(Dr.) Ashish Semwal
                    </h1>
                    <p className="text-md text-gray-600">Vice Chancellor</p>
                    <blockquote className="italic text-lg text-[#0e4d38] bg-gray-100 p-4 rounded-lg shadow-sm border-l-4 border-[#0e4d38]">
                        "The task of leadership is not to put greatness into humanity, but to elicit it, for the greatness is already there." – John Buchan
                    </blockquote>
                </div>

            </div>

            {/* Message Section */}
            <div className="w-10/12 mx-auto mt-16 flex flex-col-reverse md:flex-row items-center gap-12">
                
                <p className="text-justify text-gray-700 text-md leading-relaxed md:w-2/3">
                <h6>
                    Vice Chancellor’s Message<br /><br />
                </h6>
                    I am deeply honored and profoundly grateful for the opportunity bestowed upon me by President Shri Manohar Lal Juyal to serve as the founding Vice Chancellor of Maya Devi University. It is with great enthusiasm that I embark on this journey alongside you all.<br />
                    <br />


                    My vision for Maya Devi University is intricately woven with that of President Shri Manohar Lal Juyal, placing our country’s interests as our paramount concern while emphasizing the cultivation of exemplary character and the integration of cutting-edge innovations in science and technology. Our aim is to foster a generation of technocrats, researchers, and entrepreneurs who not only excel in their respective fields but also possess hearts brimming with peace, contentment, and unyielding passion.<br />
                    <br />


                    We believe in empowering our students to explore their passions across diverse disciplines, including technology, arts, philosophy, and beyond. Our commitment extends beyond individual pursuits; we strive to instill in our students a profound sense of responsibility towards society as a whole. With this ethos, we are dedicated to making meaningful contributions that benefit not only ourselves but also the broader community.<br /><br />



                    Central to our vision is the harmonious convergence of traditional values with the latest scientific advancements. We endeavor to bridge the gap between culture and cultivation, nurturing a generation that seamlessly integrates heritage with innovation. Our commitment to staying at the forefront of technological progress is evident in our plans to expand into areas such as AI, ML, data science, drones, and more, with a special focus on applications related to agriculture, hotel management, entrepreneurship, and beyond.<br /><br />



                    Furthermore, we recognize the vital importance of the pharmaceutical and Applied Sciences departments, and we are committed to nurturing the brightest minds in these fields<br />


                    I invite you to join us on this remarkable journey as we endeavor to uphold the esteemed legacy of Maya Devi University and contribute meaningfully to society and beyond.

                    <br /><br />



                    <span className="font-bold">
                    Prof. (Dr.) Ashish Semwal<br />

                    Vice Chancellor
                    </span>
                </p>
                <img
                    src={Img}
                    alt="Maya Devi University Logo"
                    className="rounded-xl shadow-lg w-full md:w-1/3 object-cover"
                />
            </div>

            {/* Footer */}
            <SubFooter />
            <Footer />
        </div>
    );
};

export default Vc_msg;
